import React, { useState } from 'react';

export default function Alert({ color, btnText, icon, title, subTitle }) {
  const [showAlert, setShowAlert] = useState(false);
  const handelAleftMessage = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };
  return (
    <>
      <button
        type="button"
        className={`docpro_badge docpro_badge_${color} docpro_square size_lg`}
        onClick={() => handelAleftMessage()}
      >
        {icon}
        {btnText}
      </button>
      {showAlert && (
        <div>
          <div className={`docpro_alert_message docpro_alert_${color}`}>
            <div className="docpro_alert_icon">{icon}</div>
            <div className="docpro_alert_text">
              <h2 className="docpro_fs_16">{title}</h2>
              <p className="docpro_mb_0 docpro_fs_16">{subTitle}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
